/**
 * @generated SignedSource<<4139e5cbe4640dfe82c681f14a912387>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionActionBinAndBid_viewer$data = {
  readonly originalListPricePdpFF: boolean | null;
  readonly " $fragmentType": "PdpSharedAuctionActionBinAndBid_viewer";
};
export type PdpSharedAuctionActionBinAndBid_viewer$key = {
  readonly " $data"?: PdpSharedAuctionActionBinAndBid_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionActionBinAndBid_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionActionBinAndBid_viewer",
  "selections": [
    {
      "alias": "originalListPricePdpFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "originalListPricePdp"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"originalListPricePdp\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "6d22d1a15d0f9811dd333c0631de62fd";

export default node;
